import { jsxs as a, jsx as t } from "react/jsx-runtime";
import { Children as m, cloneElement as e } from "react";
import '../../assets/AdjustableTwoColumnGrid.css';const s = {};
function d({ children: c, gap: n = "1.5rem", firstColumnWidth: l = 33, classname: r = "" }) {
  const o = m.toArray(c);
  return /* @__PURE__ */ a(
    "adjustable-two-column-layout",
    {
      style: {
        "--atcl-gap-size": n,
        "--atcl-first-column-width": typeof l == "string" ? l : `${l}%`
      },
      class: r,
      children: [
        /* @__PURE__ */ t("div", { className: s["two-column-layout__column-one"], children: e(o[0], o[0].props) }),
        /* @__PURE__ */ t("div", { className: s["two-column-layout__column-two"], children: e(o[1], o[1].props) })
      ]
    }
  );
}
export {
  d as AdjustableTwoColumnGrid,
  d as default
};
